import React from "react";
import { Col, Container, Row } from "react-bootstrap";
import Bannerfrom from "../components/bannerfrom";

function Banner(props) {
  return (
    <div className="services_banner">
      <Container className="h-100">
        <Row className="h-100">
          <Col xs={12} md={6} lg={7} xl={8} xxl={8} className="my-auto">
            <div className="banenr_content">
              <div className="example" data-text="Services">
                <h1>Transform Business Growth with Revolutionary Services</h1>
              </div>
              <div className="banner_content_txt listing_flex">
                <p>
                  Our unwavering commitment to innovation and customer
                  satisfaction drives us to deliver transformative services that
                  effectively address the ever-evolving demands of businesses in
                  the digital world, ensuring exceptional results and driving
                  impactful transformations.
                </p>
                <ul>
                  <li>Strategic roadmap planning</li>
                  <li>Cloud-based solutions</li>
                  <li>Process automation implementation</li>
                  <li>Data-driven insights</li>
                </ul>
              </div>
            </div>
          </Col>
          <Col xs={12} md={6} lg={5} xl={4} xxl={4} className="my-auto ms-auto">
            <Bannerfrom />
          </Col>
        </Row>
      </Container>
    </div>
  );
}

export default Banner;
